module.exports = __webpack_public_path__ + "static/img/productcenter.c8b4b6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-500/productcenter.jpg
// module id = 4aUE
// module chunks = 1